import React from 'react'
import PropTypes from 'prop-types'

const Trash = ({ className }) => {
    return (
        <svg
            className={className}
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1616_22125)">
                <path
                    d="M15.1875 4.4375H2.8125"
                    stroke="#404E68"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.1875 2.1875H11.8125"
                    stroke="#404E68"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.0625 4.4375V15.125C14.0625 15.2742 14.0032 15.4173 13.8977 15.5227C13.7923 15.6282 13.6492 15.6875 13.5 15.6875H4.5C4.35082 15.6875 4.20774 15.6282 4.10225 15.5227C3.99676 15.4173 3.9375 15.2742 3.9375 15.125V4.4375"
                    stroke="#404E68"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1616_22125">
                    <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

Trash.propTypes = {
    className: PropTypes.string,
}

export default Trash
